import QuillScroll from 'quill/blots/scroll';
import { isCarouselThumbnailDragStartEvent } from '../image/CarouselThumbnail';
import Block from './Block';

export default class Scroll extends QuillScroll {
  noTitleLine = false;

  static events = {
    BLOT_MOUNT: 'blot:mount',
    BLOT_UNMOUNT: 'blot:unmount',
  };

  handleDragStart(event: DragEvent) {
    if (isCarouselThumbnailDragStartEvent(event)) {
      return;
    }
    super.handleDragStart(event);
  }

  optimize(mutations = [], context = {}) {
    super.optimize(mutations, context);
    if (this.children.head == null) {
      this.insertBefore(this.create(Block.blotName), this.children.head);
      this.update();
    } else if (!(this.children.head instanceof Block)) {
      const head = this.lines()[0];
      if (head) {
        head.replaceWith(Block.blotName);
        this.update();
      }
    }
  }
}
